import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import InputLocalFile from '../input/LocalFile';
import FormFieldBase from './FieldBase';
/**@param {import('./types').FinalFormFieldLocalFileProps} props */

export var LocalFile = function LocalFile(_ref) {
  var Component = _ref.component,
      rest = _objectWithoutProperties(_ref, ["component"]);

  return React.createElement(FormFieldBase, Object.assign({
    label: rest.name
  }, rest, {
    component: undefined,
    render: function render(_ref2) {
      var input = _ref2.input,
          meta = _ref2.meta; // exclude input type (it will be put by the Component)

      var type = input.type,
          restInput = _objectWithoutProperties(input, ["type"]);

      return React.createElement(Component, Object.assign({
        error: meta.error && meta.touched
      }, rest, restInput));
    }
  }), undefined);
};
LocalFile.defaultProps = {
  component: InputLocalFile,
  onChange: function onChange(f) {
    return f;
  },
  margin: 'normal',
  variant: 'filled',
  fullWidth: true
};